/**
 * A helper for grouping products in order to hide unnecessary product options
 */
interface IProductGroupMapElement {
  list: string[],
  name: string,
}

const productsGroupMap: Record<string, IProductGroupMapElement> = {
  tours: {
    list: ['tour_admins', 'tour_agents', 'tours_reporting'],
    name: 'Tours',
  },
  listing_scores: {
    list: ['listing_scores', 'listing_scores_reporting'],
    name: 'Listing Scores',
  },
  floorplan_navigator: {
    list: ['floorplan_navigator', 'floorplan_navigator_reporting'],
    name: 'Floorplan Navigator',
  },
};

export { productsGroupMap };
